import styled from '@emotion/styled';

export const UnderTitle = styled.span`
  max-width: 90%;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: 14px;
  margin-top: 1px;
  width: auto;
  letter-spacing: 0.2px;
  color: var(--colorBlueGray200);
  line-height: 1.2;
`;
